import { render, staticRenderFns } from "./handler_ficha_inventario.vue?vue&type=template&id=21ed31ca&"
import script from "./handler_ficha_inventario.vue?vue&type=script&lang=ts&"
export * from "./handler_ficha_inventario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports